import React, { useEffect, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useParams, useNavigate, useLocation } from 'react-router-dom';

import { ActPlanoTrabalho } from './planoTrabalho';
import { SubAbasActs, SubAbasActsNovo } from './subabasActs';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomCol from '../../../../components/CustomCol';
import { CustomSwal } from '../../../../components/CustomFeedback/CustomSwal';
import CustomRow from '../../../../components/CustomRow';
import FiscalContratoComponente from '../../../../components/FiscalContrato';
import Input from '../../../../components/InputNew';
import SelectInput from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import ParteEnvolvidaComponente from '../../../../components/ParteEnvolvida';
import ResponsavelAquisicaoComponente from '../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../components/SubAbas';
import TramitacaoComponente from '../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import { getUser } from '../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../modules/contexts/Select/useSelect';
import { EnumOption } from '../../../../modules/types/types';
import { getAct } from '../../../../services/acts/actsService';
import { getAllFornecedoresSimplificado } from '../../../../services/fornecedoresDAF/fornecedorService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import {
  formataNomeMeioSiglas,
  formatDateSimp,
} from '../../../../utils/functions';
import {
  swal,
  swalAtualizacao,
  swalSave,
  swalErro,
  swalDelete,
  swalDeleteConfirm,
  swalAttention,
} from '../../../../utils/swal';
import { Fornecedor } from '../../Fornecedores/types';

export default function ActsFicha() {
  //DADOS USUARIO
  const user = getUser();
  const userID = user.sub;
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const userComponenteAF = Number(user?.vinculo?.[0]?.numeroComponenteAF ?? 0);

  //COMPONENTE
  const navigate = useNavigate();
  const params = useParams();
  const fichaID = String(params.id);

  let logs = {};
  let subAbas = [];

  //OPTIONS
  // const componenteAF = useComponentesPaf();
  const { getSelectDominioPai } = useSelect();
  const statusActOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);
  const fornecedorPapelOptions = getSelectDominioPai(58);

  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);
  //STATES
  const [logData, setLogData] = useState({
    id: '',
    usuarioRegistro: {
      nomeCompleto: '',
    },
    usuarioAtualizacao: {
      nomeCompleto: '',
    },
    dataRegistro: '',
    dataUltimaAtualizacao: '',
    dataUltimaVisualizacao: '',
    nEdicoes: '',
    nVisualizacoes: '',
    nVisualizadores: '',
  });

  const [formAct, setFormAct] = useState({
    id: 0,
    usuarioId: userID,
    fornecedorId: 0,
    fornecedorPapel: 0,
    statusAct: 0,
    componenteAf: userComponenteAF,
    numeroSeiAct: '',
    numeroAct: '',
    dataDou: '',
    dataInicio: '',
    dataVigencia: '',
    objeto: '',
    observacoes: '',
  });

  //Buscar dados
  const fetchData = async (id: string) => {
    try {
      const registroData = await getAct(id);
      setLogData(registroData);

      const dataDou = registroData.dataDou
        ? new Date(registroData.dataDou).toISOString().split('T')[0]
        : '';

      const dataInicio = registroData.dataInicio
        ? new Date(registroData.dataInicio).toISOString().split('T')[0]
        : '';

      const dataVigencia = registroData.dataVigencia
        ? new Date(registroData.dataVigencia).toISOString().split('T')[0]
        : '';

      setFormAct({
        id: registroData.id,
        usuarioId: userID,
        fornecedorId: registroData.fornecedor.id,
        fornecedorPapel: registroData.fornecedorPapel,
        statusAct: Number(registroData.statusAct),
        componenteAf: Number(registroData.componenteAf),
        dataDou: dataDou,
        dataInicio: dataInicio,
        dataVigencia: dataVigencia,
        objeto: registroData.objeto,
        numeroSeiAct: registroData.numeroSeiAct,
        numeroAct: registroData.numeroAct,
        observacoes: registroData.observacoes,
      });
      triggerRefresh(); // Dispara a atualização dos logs
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  //FORNECEDORES

  const [fornecedoresOptionsData, setFornecedoresOptionsData] = useState<
    Fornecedor[]
  >([]);
  const fetchFornecedores = async () => {
    try {
      const fornecedoresSimplificado = await getAllFornecedoresSimplificado();
      setFornecedoresOptionsData(fornecedoresSimplificado);
    } catch (error: any) {
      if (isHttpError(error)) {
        console.log(error.response?.data.message);
      }
    }
  };
  const fornecedorOptions: EnumOption[] = [
    { value: '0', label: 'Não informado' },
    ...fornecedoresOptionsData.map((item, index) => ({
      value: item.id?.toString() ?? index.toString(),
      label: item.razaoSocial
        ? item.cnpj + ' - ' + item.razaoSocial
        : 'Não informado',
    })),
  ];
  useEffect(() => {
    fetchFornecedores();
  }, []);
  const [cnpjSelecionado, setCnpjSelecionado] = useState<string>('');
  useEffect(() => {
    const fornecedor = fornecedoresOptionsData.find(
      (f) => f.id?.toString() === formAct.fornecedorId?.toString(),
    );
    setCnpjSelecionado(fornecedor?.cnpj || '');
  }, [formAct.fornecedorId, fornecedoresOptionsData]);

  //Condicional para verificar se é necessário buscar dados e ajustar subabas
  if (fichaID !== 'undefined') {
    //Buscar dados
    useEffect(() => {
      fetchData(fichaID);
    }, []);

    logs = {
      id: logData.id,
      usuarioRegistro: formataNomeMeioSiglas(
        logData.usuarioRegistro.nomeCompleto,
      ),
      usuarioAtualizacao: formataNomeMeioSiglas(
        logData.usuarioAtualizacao.nomeCompleto,
      ),
      dataRegistro: logData.dataRegistro,
      dataAtualizacao: logData.dataUltimaAtualizacao,
      nEdicoes: logData.nEdicoes,
    };

    //Subabas
    subAbas = SubAbasActs(fichaID);
  } else {
    subAbas = SubAbasActsNovo;
  }

  //Funções Handle
  const handleChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = event.target;

    setFormAct((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    // Verificar cada campo
    if (!form.statusAct) {
      errors.push('<b>Status do ACT</b> é obrigatório.');
    }

    if (!form.numeroSeiAct) {
      errors.push('<b>Nº do Processo SEI</b> é obrigatório.');
    }

    if (!form.numeroAct) {
      errors.push('<b>Nº do ACT</b> é obrigatório.');
    }

    if (Number(form.statusAct) > 53) {
      if (!form.dataDou) {
        errors.push('<b>Data DOU</b> é obrigatório.');
      }

      if (!form.dataInicio) {
        errors.push('<b>Data de Início</b> é obrigatório.');
      }

      if (!form.dataVigencia) {
        errors.push('<b>Data de Vigência</b> é obrigatório.');
      }
    }

    if (form.fornecedorId === 0) {
      errors.push('<b>Fornecedor</b> é obrigatório.');
    }

    if (form.fornecedorPapel === 0) {
      errors.push('<b>Papel do Fornecedor</b> é obrigatório.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>')); // Exibe todas as mensagens de erro no swal
      return false;
    }

    return true; // Validação bem-sucedida
  };

  const handleCreate = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }

    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formAct);
      if (!isFormValid) return;

      const formToSend = {
        ...formAct,
        statusAct: Number(formAct.statusAct),
        fornecedorId: Number(formAct.fornecedorId),
        fornecedorPapel: Number(formAct.fornecedorPapel),
        dataDou: formAct.dataDou ? formAct.dataDou : null,
        dataInicio: formAct.dataInicio ? formAct.dataInicio : null,
        dataVigencia: formAct.dataVigencia ? formAct.dataVigencia : null,
        objeto: formAct.objeto ? formAct.objeto : 'Objeto não informado.',
      };

      // const token = 'JWT_SECRET';

      const response = await httpClient.post(`/api/act/`, formToSend);

      swalSave();
      setTimeout(
        () =>
          (window.location.href = `#/daf/proaq/acts/${response.data.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleUpdate = async () => {
    try {
      // Verificar se o formulário é válido
      const isFormValid = validateForm(formAct);
      if (!isFormValid) return;

      const formToSend = {
        ...formAct,
        statusAct: Number(formAct.statusAct),
        fornecedorId: Number(formAct.fornecedorId),
        fornecedorPapel: Number(formAct.fornecedorPapel),
        dataDou: formAct.dataDou ? formAct.dataDou : null,
        dataInicio: formAct.dataInicio ? formAct.dataInicio : null,
        dataVigencia: formAct.dataVigencia ? formAct.dataVigencia : null,
        objeto: formAct.objeto ? formAct.objeto : 'Objeto não informado.',
      };

      const response = await httpClient.patch(
        `/api/act/${fichaID}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registro.id);
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();
    if (!result) {
      return;
    }

    if (result) {
      try {
        await httpClient.delete(`/api/act/${fichaID}`);
        swalDeleteConfirm();
        navigate('/daf/maisopcoes/notas');
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  //USE EFFECT
  useEffect(() => {
    const { dataDou, dataInicio } = formAct;

    if (dataDou && dataInicio) {
      const dtDou = new Date(dataDou);
      const dtTermino = new Date(dataInicio);

      if (dtTermino < dtDou) {
        setFormAct((prev) => ({
          ...prev,
          dataInicio: '',
        }));
        swalAttention(
          `A data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>DOU</b> ${formatDateSimp(dataDou)}.`,
        );
      }
    }
  }, [formAct.dataDou, formAct.dataInicio]);

  useEffect(() => {
    const { dataInicio, dataVigencia } = formAct;

    if (dataInicio && dataVigencia) {
      const dtInicio = new Date(dataInicio);
      const dtTermino = new Date(dataVigencia);

      if (dtTermino < dtInicio) {
        setFormAct((prev) => ({
          ...prev,
          dataVigencia: '',
        }));
        swalAttention(
          `A data de <b>VIGÊNCIA</b> ${formatDateSimp(dataVigencia)} <b><span style="color:red">não pode ser anterior</span></b> à data de <b>INÍCIO</b> ${formatDateSimp(dataInicio)}.`,
        );
      }
    }
  }, [formAct.dataInicio, formAct.dataVigencia]);

  const [statusStyle, setStatusStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    const emElaboracao = '#ffa600';
    const emExecucao = '#2aad35';
    const encerrado = '#1900ff';
    const suspenso = '#ff4646';
    const cancelado = '#9c0c0c';

    const status = String(formAct.statusAct);

    const newStatusStyle = {
      backgroundColor:
        status === '1'
          ? emElaboracao
          : status === '2'
            ? emExecucao
            : status === '3'
              ? encerrado
              : status === '4'
                ? suspenso
                : status === '5'
                  ? cancelado
                  : 'white',
      color: status === '0' ? 'black' : 'white',
    };

    setStatusStyle(newStatusStyle);
  }, [formAct.statusAct]);

  const [isDataRequired, setIsDataRequired] = useState(false);
  useEffect(() => {
    if (Number(formAct.statusAct) > 53) {
      setIsDataRequired(true);
    } else {
      setIsDataRequired(false);
      setFormAct((prev) => ({
        ...prev,
        dataDou: '',
        dataInicio: '',
        dataVigencia: '',
      }));
    }
  }, [formAct.statusAct]);

  //Retorno
  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/acts"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && (
            <Log
              {...logs}
              entity="TB_ACT"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Identificação do ACT */}
          <BoxConteudo boxTitulo="Identificação do ACT">
            <CustomRow
              style={{ marginTop: '-15px', justifyContent: 'flex-start' }}
            >
              <CustomCol width="220px">
                <SelectInput
                  name="statusAct"
                  options={statusActOptions}
                  label="Status"
                  value={formAct.statusAct}
                  onChange={handleChange}
                  // style={statusStyle}
                  required
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="componenteAf"
                  name="componenteAf"
                  value={
                    componenteAFoptions.find(
                      (comp) => comp.value === Number(formAct.componenteAf),
                    )?.label ?? ''
                  }
                  label="Componente AF"
                  onChange={handleChange}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="numeroSeiAct"
                  name="numeroSeiAct"
                  value={formAct.numeroSeiAct}
                  label="NUP SEI"
                  mascara="99999.999999/9999-99"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol>
                <Input
                  id="numeroAct"
                  name="numeroAct"
                  value={formAct.numeroAct}
                  label="Nº ACT"
                  onChange={handleChange}
                  required
                />
              </CustomCol>
              <CustomCol
                width="200px"
                helpText="Data de Publicação no Diário Oficial da União"
              >
                <Input
                  name="dataDou"
                  label="Data pub. DOU"
                  value={formAct.dataDou}
                  id="dataDou"
                  onChange={handleChange}
                  type="date"
                  required={isDataRequired}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataInicio"
                  name="dataInicio"
                  label="Data de Início"
                  value={formAct.dataInicio}
                  onChange={handleChange}
                  type="date"
                  required={isDataRequired}
                />
              </CustomCol>
              <CustomCol width="200px">
                <Input
                  id="dataVigencia"
                  name="dataVigencia"
                  label="Data de Vigência"
                  value={formAct.dataVigencia}
                  onChange={handleChange}
                  type="date"
                  required={isDataRequired}
                />
              </CustomCol>
            </CustomRow>

            {/* Fornecedor */}
            <CustomRow>
              <CustomCol width="220px">
                <Input
                  id="cnpj"
                  name="cnpj"
                  label="CNPJ"
                  value={cnpjSelecionado}
                  // eslint-disable-next-line @typescript-eslint/no-empty-function
                  onChange={() => {}}
                  readonly
                />
              </CustomCol>
              <CustomCol>
                <SelectInput
                  name="fornecedorId"
                  value={formAct.fornecedorId}
                  options={fornecedorOptions}
                  onChange={handleChange}
                  label="Fornecedor"
                  disabled={formAct.id === 0 ? false : true}
                  required
                />
              </CustomCol>
              <CustomCol width="250px">
                <SelectInput
                  name="fornecedorPapel"
                  value={formAct.fornecedorPapel}
                  options={fornecedorPapelOptions}
                  onChange={handleChange}
                  label="Papel do Fornecedor"
                  disabled={formAct.id === 0 ? false : true}
                  required
                />
              </CustomCol>
            </CustomRow>

            {/* Descrição */}
            <CustomRow>
              <CustomCol>
                <Input
                  id="objeto"
                  name="objeto"
                  label="Objeto do ACT"
                  value={formAct.objeto}
                  onChange={handleChange}
                  type="textarea"
                  linhas={3}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>

          {fichaID !== 'undefined' && (
            <>
              {/* Plano de Trabalho */}
              <ActPlanoTrabalho
                novoRegistro={Number(fichaID) == 0 ? false : true}
                componente={Number(
                  componenteAFoptions[formAct.componenteAf]?.value,
                )}
                idAct={Number(fichaID)}
                actLabel={formAct.numeroAct}
              ></ActPlanoTrabalho>

              {/* Seção Partes Envolvidas */}
              <ParteEnvolvidaComponente tab="act" id_tab={fichaID} />

              {/* Seção Fiscal do Contrato */}
              <FiscalContratoComponente tab="act" id_tab={fichaID} />

              {/* Seção Responsáveis da Aquisição */}
              <ResponsavelAquisicaoComponente tab="act" id_tab={fichaID} />

              {/* Seção Termo Aditivo */}
              {/* <TermoAditivoComponente tab="act" id_tab={fichaID} /> */}

              {/* Seção Tramitação SEI */}
              <TramitacaoComponente tab="act" id_tab={fichaID} />
            </>
          )}

          {/* Observações */}
          <BoxConteudo boxTitulo="Observações" fechado>
            <CustomRow style={{ marginTop: '-15px' }}>
              <CustomCol>
                <Input
                  id="observacoes"
                  name="observacoes"
                  value={formAct.observacoes}
                  label=""
                  type="textarea"
                  onChange={handleChange}
                  linhas={5}
                />
              </CustomCol>
            </CustomRow>
          </BoxConteudo>
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
}
